import { useQueries } from "@tanstack/react-query";
import { ProfileService } from "../services/profile";
import { RegionService } from "../services/region";

export function useGetProfile() {
    const [profileQuery, timeZonesQuery, languagesQuery] = useQueries({
        queries: [
            {
                queryKey: ['getProfile'],
                queryFn: ProfileService.getProfile
            },
            {
                queryKey: ['getTimeZones'],
                queryFn: RegionService.getTimezones,

            },
            {
                queryKey: ['getLanguages'],
                queryFn: RegionService.getLanguages,
            }
        ]
    })

    return {
        isLoading: profileQuery.isFetching || timeZonesQuery.isFetching || languagesQuery.isFetching,
        profileResponse: profileQuery.data,
        timeZones: timeZonesQuery.data,
        languages: languagesQuery.data,
        error: profileQuery.error || timeZonesQuery.error  || languagesQuery.error
    }
}